<template>
  <div class="main navigation">
    <div class="top">
      测评分为五大部分，包括：人格特性、智能水平、兴趣倾向、职业价值观和心理适应性测试。<br>
      <span>请单击{{datas[part].name}}部分进行测试。</span>
    </div>
    <ul class="bottom">
      <li  v-for="(item,index) in datas" :style='{backgroundImage:`url(/imgs/careerEvaluation/navigation/part${index+1}.png)`}' @click="go(index,item.url)" :key="index" :class="index==part?'scale':''">
        <img src="/imgs/careerEvaluation/navigation/finish.png" alt="" v-show="index<part">
        <p :style='{paddingTop:index<=part?paddingTop:""}'>{{item.name}}</p>
        <div class="button" v-show="index<=part" :style='{background:index<part?"#ACA9A9":item.color}'>
          <template v-if="index<part">已完成</template>
          <template v-if="index>=part">开始测试</template>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data(){
    return{
      datas:[
        {name:'人格特性',color:'#F8767D',url:{path:'/careerevalution/home',query:{name:'rgtx',part:'main'}}},
        {name:'智能水平',color:'#2F8CF6',url:{path:'/careerevalution/home',query:{name:'znsp',part:'main'}}},
        {name:'兴趣倾向',color:'#FDB638',url:{path:'/careerevalution/home',query:{name:'xqqx',part:'main'}}},
        {name:'职业价值观',color:'#17D3AC',url:{path:'/careerevalution/home',query:{name:'zyjzg',part:'main'}}},
        {name:'心理适应性',color:'#9D77FC',url:{path:'/careerevalution/home',query:{name:'xlssx',part:'main'}}}
      ],
      part:this.$route.query.part||0,
      paddingTop:'262px'
    }
  },
  methods:{
    go(index,url){
      if(index==this.part){
        this.$router.push(url)
      }
    },
  },
  mounted() {
    let width=$(window).width();
    let height=$(window).height();
    this.paddingTop = width<1450?'209.6px':'262px'

    window.addEventListener('resize',function (){
      let width=$(window).width();
       this.paddingTop = width<1450?'209.6px':'262px'
    }.bind(this))
  }
}
</script>

<style scoped lang="less">
.main{
  padding-top: 120px;
  .top{
    width: 1200px;
    margin: 0 auto;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
    span{
      color:#6BF1FF
    }
  }

  .bottom{
    width: 1450px;
    margin:80px auto;
    display: flex;
    justify-content: space-between;
    li{
      width: 256px;
      height: 377px;
      background-size: 100% 100%;
      position: relative;
      img{
        position: absolute;
        left: 0;
        top: 0;
      }
      p{
        height: 33px;
        font-size: 24px;
        padding-top: 290px;
        text-align: center;
        color:#fff;
      }
      .button{
        width: 120px;
        height: 34px;
        background: #F8767D;
        border-radius: 17px;
        line-height: 32px;
        margin: 30px auto;
        text-align: center;
        color:#fff;
        vertical-align:middle;
        box-sizing: border-box;
      }
    }
    .scale{
      cursor: pointer;
      &:hover{
        transform: scale(1.05) !important;
        cursor: pointer;
        transition: .1s;
      }
      &:hover .button{
        transition: .1s;
        background: #fff !important;

      }
      &:nth-of-type(1):hover .button{
        color:#F8767D !important;
      }
      &:nth-of-type(2):hover .button{
        color:#2F8CF6 !important;
      }
      &:nth-of-type(3):hover .button{
        color:#FDB638 !important;
      }
      &:nth-of-type(4):hover .button{
        color:#17D3AC !important;
      }
      &:nth-of-type(5):hover .button{
        color:#9D77FC !important;
      }
    }
  }
  @media screen and (max-width: 1450px){
    .bottom{
      width: 1200px !important;
      li{
        width: 204.8px;
        height: 301.6px;
        p{
          height: 26.4px;
          font-size: 19.2px;
          padding-top: 232px;
          text-align: center;
          color:#fff;
        }
        .button{
          width: 96px;
          height: 27.2px;
          background: #F8767D;
          border-radius: 13.6px;
          line-height: 27.2px;
          margin: 24px auto;
          text-align: center;
          color:#fff;
          vertical-align:middle;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>